module.exports = "/_next/static/images/moon-f081f9c332d5e94932762dc62ac30c02.png";